module.exports = __webpack_public_path__ + "static/media/siddharth-balcony.aad868e3.jpg";